<template>
  <Loader :loader="loaderActive"/>
  <div class="container-fluid">
    <div class="row">
      <div class="category-head">
        <div class="back-link">
          <a @click="$router.back()">←</a>
        </div>
        <div class="category-title">
          <p>ক্যাটাগরি</p>
        </div>
      </div>
    </div>

    <div class="row d-flex gap-5 ">
      <div class="col-sm-2 card " v-for="category in allCategoryList" :key="category.category_id">
        <div class="d-flex flex-column justify-content-center align-items-center">
          <div class="star">
            <i class="fas fa-star" v-if="! category.following"
               @click="removeAddFavoriteCategory(category.id, true)"></i>
            <i class="fas fa-star " v-if="category.following" style="color: #F6961B"
               @click="removeAddFavoriteCategory(category.id, false)"></i>
          </div>
          <router-link :to="{ path: '/category-sub-list', query: {
          category_id: category.id,
          type: 'category',
          page_title: category.name
        } }" class="d-flex flex-column justify-content-center align-items-center" >
            <img :src="category.image_url" alt="Card image">
            <p class=" ">{{ category.name }} </p>
          </router-link>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {sendRequest} from "@/http/axios.method";
import Loader from "@/views/components/Loader";

export default {
  name: "CategoryList",
  components: {
    Loader,
  },
  data() {
    return {
      loaderActive: false,
      config: {
        'AUTHORIZATION': 'Bearer ' + this.$store.state.authUser.token
      },
      categoryList: [],
    }
  },
  created() {
    this.getCategoryList();
  },
  methods: {
    getCategoryList() {
      this.loaderActive = true;
      sendRequest('get', 'v2.0/categories', {category_id: this.categoryId}, this.config)
          .then(response => {
            this.loaderActive = false;
            if (response.success) {
              this.categoryList = response.data.category_list;
            }
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
    removeAddFavoriteCategory(category_id, category_follow) {
      this.loaderActive = true;
      let data = {
        category_id: category_id,
      }
      sendRequest('post', 'v2.0/remove-favourite-category', data, this.config)
          .then(response => {
            this.loaderActive = false;
            if (response.success) {
              this.categoryList = this.categoryList.map(category => {
                if (category.id === category_id) {
                  return {...category, following: category_follow};
                }
                return category;
              });
            }
          })
          .catch(() => {
            this.loaderActive = false;
          });
    },
  },
  computed: {
    allCategoryList() {
      return this.categoryList;
    }
  }
}
</script>

<style scoped>

</style>
